import { ButtonHTMLAttributes } from "react"
import { FaSpinner } from "react-icons/fa"

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    color?: string,
    children: React.ReactNode,
    disabled?: boolean,
    width?: string,
    textColor?: string,
    styleButton?: string,
    naoExibeCarregando?: boolean,
    onClick?: () => void

}

export const Button = ({ color, children, disabled, onClick, width, textColor, styleButton, naoExibeCarregando = true, ...rest }: ButtonProps) => {
    return (
        <button
            {...rest}
            disabled={disabled}
            className={`flex decoration-transparent gap-2 items-center justify-center px-3 py-2.5 rounded-lg text-sm md:text-base hover:opacity-80 disabled:cursor-not-allowed disabled:opacity-50 
                        ${styleButton && styleButton} ${width ? width : null}  ${textColor ? textColor : 'text-white'} ${color !== undefined ? color : 'bg-rifaweb-primario'}`}
            onClick={onClick}
        >
            {disabled && naoExibeCarregando ?
                <div className="px-4 text-2xl animate-spin text-white"><FaSpinner /></div>
                : children
            }
        </button>
    )
}